import {SeasonModel} from '@/Pages/Admin/Modules/Models/Master/SeasonModel';

export class TrekPriceDurationModel {
    public id: number;
    public min_people: number;
    public max_people: number;
    public min_age: number;
    public max_age: number;
    public duration_days: number;
    public duration_nights: number;
    public trek_seasons:SeasonModel = new SeasonModel({});
    public bookings_count: number;
    public pre_bookings_count: number;
    public duration: string;
    public age_range: string;
    public people_range: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.min_people = obj.min_people ? obj.min_people : 0;
        this.max_people = obj.max_people ? obj.max_people : 0;
        this.min_age = obj.min_age ? obj.min_age : 0;
        this.max_age = obj.max_age ? obj.max_age : 0;
        this.duration_days = obj.duration_days ? obj.duration_days : 0;
        this.duration_nights = obj.duration_nights ? obj.duration_nights : 0;
        this.trek_seasons = obj.trek_seasons
            ? obj.trek_seasons
            : new SeasonModel({});
        this.bookings_count = obj.bookings_count ? obj.bookings_count : 0;
        this.pre_bookings_count = obj.pre_bookings_count
            ? obj.pre_bookings_count
            : 0;
        this.duration = obj.duration ? obj.duration : '';
        this.age_range = obj.age_range ? obj.age_range : '';
        this.people_range = obj.people_range ? obj.people_range : '';
    }
}
